import React, { FC } from "react";

import SimpleButton from "global/SimpleButton/SimpleButton";

interface SurveyFormFooterActionsProps {
  isEditMode: boolean;
  onCancel: () => void;
}

const SurveyFormFooterActions: FC<SurveyFormFooterActionsProps> = ({
  isEditMode,
  onCancel,
}) => {
  return (
    <div className="sticky bottom-4 mt-8 z-20">
      <div className="bg-white/90 backdrop-blur rounded-3xl border border-gray-100 shadow-lg p-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-xs md:text-sm text-gray-500">
          {isEditMode
            ? "پس از ویرایش، تغییرات روی فرم ذخیره خواهد شد."
            : "پس از ثبت، فرم نظرسنجی ایجاد می‌شود."}
        </div>

        <div className="flex items-center gap-3 w-full sm:w-auto">
          <SimpleButton
            type="button"
            text="انصراف"
            className="!bg-gray-100 !text-gray-700 px-6 !rounded-2xl w-full sm:w-auto"
            handelClick={onCancel}
          />
          <SimpleButton
            type="submit"
            text={isEditMode ? "ذخیره تغییرات" : "ایجاد نظرسنجی"}
            className="!bg-[#7a1b2b] !text-white px-8 !rounded-2xl w-full sm:w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default SurveyFormFooterActions;
